import { WebSource } from "../../../../model/types"

export type SourceReaderMode = "markdown" | "stored" | "live"

export const hasStoredContentEndpoint = (source: WebSource): boolean => {
  if (source.hasStoredContent) return true
  if (source.type === "tweet") return true
  return isXStatusSource(source)
}

export const hasStoredMarkdown = (source: WebSource): boolean => !!source.hasStoredMarkdown

export const isPdfSource = (source: WebSource): boolean =>
  source.type === "pdf" || source.contentFileContentType === "application/pdf"

export const isXStatusSource = (source: WebSource): boolean => {
  if (source.type === "tweet") return true
  if (!source.url) return false

  try {
    const url = new URL(source.url)
    const host = url.hostname.toLowerCase()
    return (
      /^(www\.)?(twitter|x)\.com$/.test(host) &&
      url.pathname.split("/").some((part) => part.toLowerCase() === "status")
    )
  } catch (_error) {
    return false
  }
}

export const sourceContentUrl = (source: WebSource): string =>
  `/api/sources/${encodeURIComponent(String(source.id))}/content`

export const sourceMarkdownUrl = (source: WebSource): string =>
  `/api/sources/${encodeURIComponent(String(source.id))}/markdown`

export const canUseLiveSource = (source: WebSource): boolean =>
  !!source.url && source.iframeForbidden !== true

export const canUseReadingPane = (source: WebSource): boolean =>
  hasStoredMarkdown(source) || hasStoredContentEndpoint(source) || canUseLiveSource(source)

export const preferredReaderMode = (source: WebSource): SourceReaderMode => {
  if (isPdfSource(source)) {
    return hasStoredContentEndpoint(source) || !canUseLiveSource(source) ? "stored" : "live"
  }
  if (hasStoredMarkdown(source)) return "markdown"
  if (hasStoredContentEndpoint(source)) return "stored"
  return "live"
}
